<template>
  <nav id="site-navigation" class="main-navigation" aria-label="Primary" itemtype="https://schema.org/SiteNavigationElement" itemscope>
    <div class="inside-navigation">
      <router-link class="brand" to="/">
        <img class="header-image is-logo-image" alt="Secure VPN" src="@/assets/vpn/vpn-logo.webp">
        <span>Secure VPN</span>
      </router-link>

      <button class="menu-toggle" type="button" aria-label="Toggle menu" @click="isMenuClicked = !isMenuClicked">
        <span :class="{ open: isMenuClicked }"></span>
      </button>

      <ul class="menu" :class="{ open: isMenuClicked }">
        <li><router-link to="/" @click.native="isMenuClicked = false">{{ navCopy.home }}</router-link></li>
        <li><router-link to="/web-proxy/" @click.native="isMenuClicked = false">{{ navCopy.webProxy }}</router-link></li>
        <li><router-link to="/for-pc/" @click.native="isMenuClicked = false">{{ navCopy.forPc }}</router-link></li>
        <li><router-link to="/what-is-my-ip/" @click.native="isMenuClicked = false">{{ navCopy.ipChecker }}</router-link></li>
        <li><router-link to="/blogs/" @click.native="isMenuClicked = false">{{ navCopy.blog }}</router-link></li>
        <li class="menu-dropdown">
          <details class="nav-dropdown">
            <summary>
              {{ selectedLocationLabel }}
              <span class="dropdown-arrow" aria-hidden="true">&#9662;</span>
            </summary>
            <ul class="dropdown-menu locations-menu">
              <li v-for="location in locationLinks" :key="location.key">
                <router-link :to="location.path" @click.native="isMenuClicked = false">
                  {{ location.label }}
                </router-link>
              </li>
            </ul>
          </details>
        </li>
        <!-- <li><router-link to="/download/" class="download-btn" @click.native="isMenuClicked = false">Download</router-link></li> -->
      </ul>
    </div>
  </nav>
</template>

<script>
import '@/css/vpn-theme.scss';
import { getLocationLinks, getNavigationCopy } from '@/documents/vpnNavigation';

export default {
  name: 'HeadNav',
  props: {
    selectedLanguage: {
      type: String,
      required: false,
      default: 'en',
    },
    page: {
      type: String,
      required: false,
      default: 'gb',
    },
  },
  data() {
    return {
      isMenuClicked: false,
    };
  },
  computed: {
    navCopy() {
      return getNavigationCopy(this.selectedLanguage);
    },
    locationLinks() {
      return getLocationLinks();
    },
    selectedLocationLabel() {
      const localeKey = this.$route.meta.localeKey;
      const selectedLocation = this.locationLinks.find((location) => location.key === localeKey);

      return selectedLocation ? selectedLocation.label : this.navCopy.locations;
    },
  },
};
</script>

<style lang="scss" scoped>
#site-navigation {
  position: sticky;
  top: 0;
  z-index: 30;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(14px);
  border-bottom: 1px solid rgba(15, 48, 74, 0.06);
  font-family: var(--vpn-font);
}

.inside-navigation {
  width: var(--vpn-container);
  min-height: 72px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--vpn-ink);
  font-weight: 800;
  font-size: 19px;
  letter-spacing: -0.02em;
  text-decoration: none;
}

.brand img {
  width: 36px;
  height: 36px;
  object-fit: contain;
}

.menu {
  box-sizing: border-box;
  list-style: none !important;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 !important;
  padding: 0;
}

.menu li {
  list-style: none !important;
  margin: 0;
  padding: 0;
}

.menu a {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  padding: 0 14px;
  color: var(--vpn-ink-soft);
  font-weight: 600;
  text-decoration: none;
  border-radius: 999px;
  transition: color 0.2s ease, background 0.2s ease;
}

.menu a:hover {
  color: var(--vpn-ink);
  background: rgba(91, 79, 232, 0.08);
}

.menu-dropdown {
  position: relative;
}

.nav-dropdown {
  position: relative;
}

.nav-dropdown summary {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  padding: 0 14px;
  color: var(--vpn-ink-soft);
  font-weight: 600;
  cursor: pointer;
  list-style: none;
  border-radius: 999px;
  transition: color 0.2s ease, background 0.2s ease;
}

.nav-dropdown summary::-webkit-details-marker {
  display: none;
}

.nav-dropdown summary:hover,
.nav-dropdown[open] summary {
  color: var(--vpn-ink);
  background: rgba(91, 79, 232, 0.08);
}

.dropdown-arrow {
  font-size: 10px;
  line-height: 1;
  transition: transform 0.2s ease;
}

.nav-dropdown[open] .dropdown-arrow {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 40;
  min-width: 210px;
  margin: 0 !important;
  padding: 8px !important;
  list-style: none !important;
  border: 1px solid var(--vpn-line);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 18px 42px rgba(18, 18, 46, 0.16);
}

.locations-menu {
  right: 0;
  left: auto;
  min-width: 190px;
}

.dropdown-menu a {
  width: 100%;
  justify-content: flex-start;
  min-height: 36px;
  border-radius: 9px;
  white-space: nowrap;
}

.download-btn {
  margin-left: 6px;
  background: linear-gradient(135deg, var(--vpn-teal-bright), var(--vpn-teal)) !important;
  color: #fff !important;
  font-weight: 800 !important;
  box-shadow: 0 8px 18px rgba(91, 79, 232, 0.28);
}

.download-btn:hover {
  background: linear-gradient(135deg, #8b7cff, var(--vpn-teal-deep)) !important;
}

.menu-toggle {
  display: none;
  width: 42px;
  height: 42px;
  border: 0;
  border-radius: 12px;
  background: var(--vpn-surface-soft);
  padding: 0;
  place-items: center;
}

.menu-toggle span,
.menu-toggle span::before,
.menu-toggle span::after {
  display: block;
  width: 18px;
  height: 2px;
  background: var(--vpn-ink);
  border-radius: 2px;
  position: relative;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.menu-toggle span::before,
.menu-toggle span::after {
  content: '';
  position: absolute;
  left: 0;
}

.menu-toggle span::before {
  top: -6px;
}

.menu-toggle span::after {
  top: 6px;
}

.menu-toggle span.open {
  background: transparent;
}

.menu-toggle span.open::before {
  top: 0;
  transform: rotate(45deg);
}

.menu-toggle span.open::after {
  top: 0;
  transform: rotate(-45deg);
}

@media (max-width: 760px) {
  .inside-navigation {
    min-height: 64px;
    position: relative;
  }

  .menu-toggle {
    display: grid;
  }

  .menu {
    display: none;
    position: absolute;
    top: calc(100% + 1px);
    left: 0;
    right: 0;
    flex-direction: column;
    gap: 4px;
    padding: 12px;
    background: rgba(255, 255, 255, 0.98);
    border-bottom: 1px solid var(--vpn-line);
    box-shadow: var(--vpn-shadow);
  }

  .menu.open {
    display: flex;
  }

  .menu a {
    width: 100%;
    justify-content: center;
  }

  .menu-dropdown,
  .nav-dropdown {
    width: 100%;
  }

  .nav-dropdown summary {
    width: 100%;
    justify-content: center;
  }

  .dropdown-menu,
  .locations-menu {
    position: static;
    min-width: 0;
    margin-top: 4px !important;
    border: 0;
    box-shadow: none;
    background: rgba(91, 79, 232, 0.05);
  }

  .dropdown-menu a {
    justify-content: center;
  }

  .download-btn {
    margin-left: 0;
  }
}
</style>
